// extracted by mini-css-extract-plugin
module.exports = {"tooltipAnchor":"sR","tooltipContainer":"sS","showTooltip":"sT","customTooltip":"sU","srp_grid_price":"sV","srp_grid_property":"sW","vdp_price_details":"sX","srp_row_property":"sY"};